import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class OnlyCustomersGuardService {
  protected readonly onDestroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store
        .pipe(select(fromAppRoot.selectCurrentAccount))
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          if (!value || !value.step_status) {
            return;
          }
          if (value.step_status < 5 || value.kind === 'grow') {
            // Select correct account before redirection
            if (route.queryParams.account) {
              void this.router.navigateByUrl(`/?account=${route.queryParams.account as string}`);
            } else {
              void this.router.navigateByUrl('/');
            }
            observer.next(false);
          } else {
            observer.next(true);
          }
          this.onDestroy$.next();
          this.onDestroy$.complete();
        });
    });
  }
}

export const OnlyCustomersGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  return inject(OnlyCustomersGuardService).canActivate(route);
};
